import HttpService from "../util/HttpService";

const CONTEXT_PATH = "/cwm/api/v2";
class UserAccessService {
    getSideMenuList = () => {
        return HttpService.get(CONTEXT_PATH.concat("/user-access/menu-list"));
    }
    getSessionTime = () => {
        return HttpService.get(CONTEXT_PATH.concat("/user-access/session-time"));
    }

    getSideMenuListRoleWise = () => {
        return HttpService.get("/video/api/v2/user-access/menu-list/list");
    }

    getRolesList = () => {
        return HttpService.get("/video/api/v2/user-access/role-list");
    }

    createGroup = (data: any) => {
        return HttpService.post("/video/api/v2/user-access/groups", data);
    }

    updateGroup = (data: any) => {
        return HttpService.put("/video/api/v2/user-access/groups", data);
    }

    getGroup = (id: string) => {
        return HttpService.get("/video/api/v2/user-access/group/" + id);
    }

    getSideMenuRoleList = () => {
        return HttpService.get("/video/api/v2/user-access/side-menu-role-list/list");
    }

    updateUserStatus = (userId: string, status: boolean) => {
        return HttpService.put("/video/api/v2/user-access/activate/" + userId + "/" + status, null);
    }



    getAllUserList = () => {
        return HttpService.get("/common/api/v2/user-allocation/all-user-list");
    }

    getLoginUserDetail = () => {
        return HttpService.get("/common/api/v2/user-allocation/login-user-detail");
    }
}

const userAccessService = new UserAccessService();
export default userAccessService;
